import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { OPT_IN_CONTENT_BLOCKER_ALL } from "../../types";
import { OPT_IN_CONTENT_BLOCKER } from "../../types";
import { HTML_ATTRIBUTE_COOKIE_IDS } from "..";
/**
 * Listen to clicked content blockers and automatically delegate the click
 * event to the underlying element. This is especially useful for overlays of videos
 * so the user does not need to click twice.
 */

function delegateClickThroughUnblockedContent() {
  document.addEventListener(OPT_IN_CONTENT_BLOCKER, /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var _ref$detail, element, gotClicked, delegateClick, nextElementSibling, parentElement, parentElementNextSibling, _iterator, _step, _step$value, node, selectors, _iterator2, _step2, selector, childrenSelected, fn;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref$detail = _ref.detail, element = _ref$detail.element, gotClicked = _ref$detail.gotClicked;

              if (!gotClicked) {
                _context.next = 44;
                break;
              }

              nextElementSibling = element.nextElementSibling;
              parentElement = element.parentElement;
              parentElementNextSibling = parentElement === null || parentElement === void 0 ? void 0 : parentElement.nextElementSibling;
              _iterator = _createForOfIteratorHelper([[// Same element (= the blocked element)
              element, [// Ultimate Video (WP Bakery Page Builder)
              ".ultv-video__play", // Elementor
              ".elementor-custom-embed-image-overlay", // Themify
              ".tb_video_overlay", // Premium Addons for Elementor
              ".premium-video-box-container"]], [// Next sibling element to the blocked content
              nextElementSibling, [// JetElements for Element
              ".jet-video__overlay"]], [// Next sibling element of parent of the blocked content
              parentElementNextSibling, [// Divi Page Builder
              ".et_pb_video_overlay"]]]);
              _context.prev = 6;

              _iterator.s();

            case 8:
              if ((_step = _iterator.n()).done) {
                _context.next = 35;
                break;
              }

              _step$value = _slicedToArray(_step.value, 2), node = _step$value[0], selectors = _step$value[1];

              if (!node) {
                _context.next = 33;
                break;
              }

              _iterator2 = _createForOfIteratorHelper(selectors);
              _context.prev = 12;

              _iterator2.s();

            case 14:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 25;
                break;
              }

              selector = _step2.value;

              if (!node.matches(selector)) {
                _context.next = 19;
                break;
              }

              delegateClick = node;
              return _context.abrupt("break", 35);

            case 19:
              // Check for children selector
              childrenSelected = node.querySelector(selector);

              if (!childrenSelected) {
                _context.next = 23;
                break;
              }

              delegateClick = childrenSelected;
              return _context.abrupt("break", 35);

            case 23:
              _context.next = 14;
              break;

            case 25:
              _context.next = 30;
              break;

            case 27:
              _context.prev = 27;
              _context.t0 = _context["catch"](12);

              _iterator2.e(_context.t0);

            case 30:
              _context.prev = 30;

              _iterator2.f();

              return _context.finish(30);

            case 33:
              _context.next = 8;
              break;

            case 35:
              _context.next = 40;
              break;

            case 37:
              _context.prev = 37;
              _context.t1 = _context["catch"](6);

              _iterator.e(_context.t1);

            case 40:
              _context.prev = 40;

              _iterator.f();

              return _context.finish(40);

            case 43:
              // We delegate the click to an element, let's check if it is also blocked and listen to unblock
              if (delegateClick) {
                fn = function fn() {
                  return setTimeout(function () {
                    return delegateClick.click();
                  },
                  /* Let's delay so we can start after `manipulateDom#customTriggers()` */
                  100);
                };

                if (delegateClick.hasAttribute(HTML_ATTRIBUTE_COOKIE_IDS)) {
                  delegateClick.addEventListener(OPT_IN_CONTENT_BLOCKER_ALL, fn, {
                    once: true
                  });
                } else {
                  fn();
                }
              }

            case 44:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 37, 40, 43], [12, 27, 30, 33]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
}

export { delegateClickThroughUnblockedContent };